/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DetailedShipmentReport } from "./DetailedShipmentReport";
import {
  DetailedShipmentReportFromJSON,
  DetailedShipmentReportFromJSONTyped,
  DetailedShipmentReportToJSON,
  DetailedShipmentReportToJSONTyped,
} from "./DetailedShipmentReport";
import type { LookupResultType } from "./LookupResultType";
import {
  LookupResultTypeFromJSON,
  LookupResultTypeFromJSONTyped,
  LookupResultTypeToJSON,
  LookupResultTypeToJSONTyped,
} from "./LookupResultType";

/**
 *
 * @export
 * @interface LookupResult
 */
export interface LookupResult {
  /**
   *
   * @type {LookupResultType}
   * @memberof LookupResult
   */
  resultType: LookupResultType;
  /**
   *
   * @type {string}
   * @memberof LookupResult
   */
  resultId?: string | null;
  /**
   *
   * @type {Array<DetailedShipmentReport>}
   * @memberof LookupResult
   */
  resultList?: Array<DetailedShipmentReport> | null;
}

/**
 * Check if a given object implements the LookupResult interface.
 */
export function instanceOfLookupResult(value: object): value is LookupResult {
  if (!("resultType" in value) || value["resultType"] === undefined)
    return false;
  return true;
}

export function LookupResultFromJSON(json: any): LookupResult {
  return LookupResultFromJSONTyped(json, false);
}

export function LookupResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LookupResult {
  if (json == null) {
    return json;
  }
  return {
    resultType: LookupResultTypeFromJSON(json["resultType"]),
    resultId: json["resultId"] == null ? undefined : json["resultId"],
    resultList:
      json["resultList"] == null
        ? undefined
        : (json["resultList"] as Array<any>).map(
            DetailedShipmentReportFromJSON,
          ),
  };
}

export function LookupResultToJSON(json: any): LookupResult {
  return LookupResultToJSONTyped(json, false);
}

export function LookupResultToJSONTyped(
  value?: LookupResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    resultType: LookupResultTypeToJSON(value["resultType"]),
    resultId: value["resultId"],
    resultList:
      value["resultList"] == null
        ? undefined
        : (value["resultList"] as Array<any>).map(DetailedShipmentReportToJSON),
  };
}
